import { useEffect, useState } from 'react';
import useSWR from 'swr';
import { useParams } from 'react-router-dom';
import Loader from '../../../../components/Feedback/Loader';
import baseService from '../../../../services/base';
import { fetchData } from '../../../../services/fetch';
import CertificationEditForm from './CertificationEditForm';
import CertificationEditFormSimple from './Simple';

export default function CertificationEdit() {
 const { id: surveyId } = useParams();
 const [defaultValues, setDefaultValues] = useState();
 const [isFormUpdated, setIsFormUpdated] = useState(false);

 const { data, isLoading, mutate } = useSWR(
  surveyId ? `survey/certificate/${surveyId}/survey` : null,
  fetchData
 );

 useEffect(() => {
  if (data && !isFormUpdated) {
   // Transformar os dados para os valores padrão do formulário
   const transformedPillars = data?.pillars?.map((pillar) => ({
    pillarId: pillar.id_pillar,
    pillarName: pillar.name_pillar,
    pillarText: pillar?.text_pillar,
    pillarImage: pillar?.img_pillar,
    questions: pillar?.questions || [],
   }));

   setDefaultValues({
    name: data.description,
    form: transformedPillars || [],
    questions: data?.questions,
    hasPillars: data?.has_pillar ? 'Sim' : 'Não',
   });

   setIsFormUpdated(true);
  }
 }, [data, isFormUpdated]);

 if (isLoading || !isFormUpdated || !defaultValues) {
  return <Loader />;
 }
 return (
  <>
   {data?.has_pillar ? (
    <CertificationEditForm
     defaultValues={defaultValues}
     data={data}
     surveyId={surveyId}
     mutate={mutate}
    />
   ) : (
    <CertificationEditFormSimple
     defaultValues={defaultValues}
     data={data}
     surveyId={surveyId}
     mutate={mutate}
    />
   )}
  </>
 );
}
